import { Component } from '@angular/core';
var NotFoundComponent = /** @class */ (function () {
    function NotFoundComponent() {
    }
    NotFoundComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    template: 'Not Found'
                }] }
    ];
    return NotFoundComponent;
}());
export { NotFoundComponent };
//# sourceMappingURL=notfound.component.js.map